module.exports = __webpack_public_path__ + "media/images/workplace/emojis/sad-36c8178668f2fac45605d00326848185.png";